import PropTypes from "prop-types";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  FormHelperText,
  Grid,
  Stack,
  Snackbar,
  Alert, TextField,
  Typography
} from "@mui/material";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  LOGIN_PAGE,
  API_ERROR_MESSAGE,
  API_SUCCESS_MESSAGE,
} from "../../shared/constants";
import AuthWrapper from "../../components/Authwrapper";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [snackData, setSnackData] = useState({
    show: false,
    message: "",
    type: "error",
  });

  const handleSubmitForm = (values, { setSubmitting }) => {
    navigate("/otp",{state:{showPage:true}});
    // let payload = values;
    // AuthApiService.forgotPassword(payload)
    //   .then((response) => {
    //       setSnackData({
    //         show: true,
    //         message: response?.message || API_SUCCESS_MESSAGE.OTP_SENT,
    //         type: "success",
    //       });
    //       navigate("/otp",{state:{showPage:true}});
    //   })
    //   .catch((errResponse) => {
    //     setSnackData({
    //       show: true,
    //       message: errResponse?.error?.message || API_ERROR_MESSAGE.INCORRECT_EMAIL,
    //       type: "error",
    //     });
    //     setSubmitting(false); // This will reset isSubmitting in Formik
    //   });
  };

  return (
    <>
      <AuthWrapper>
        <Formik
          initialValues={{
            email: "",
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .email(LOGIN_PAGE.EMAIL_ERROR)
              .max(255)
              .required(LOGIN_PAGE.EMAIL_REQUIRED_MESSAGE),
          })}
          onSubmit={handleSubmitForm} // Using Formik's onSubmit directly
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
          }) => (
            <form noValidate onSubmit={handleSubmit}>
              <Grid container spacing={3}>
              <Grid item xs={12}><Typography>Forgot Password</Typography></Grid>
                <Grid item xs={12}>
                  <Stack spacing={1}>
                    <TextField
                      required
                      id="email-login"
                      type="email"
                      value={values.email}
                      label={LOGIN_PAGE.EMAIL}
                      name="email"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder={LOGIN_PAGE.EMAIL_INPUT_PLACEHOLDER}
                      fullWidth
                      error={Boolean(touched.email && errors.email)}
                    />
                  </Stack>
                  {touched.email && errors.email && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-email-login"
                    >
                      {errors.email}
                    </FormHelperText>
                  )}
                </Grid>

                {errors.submit && (
                  <Grid item xs={12}>
                    <FormHelperText error>{errors.submit}</FormHelperText>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Button
                    disableElevation
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    {LOGIN_PAGE.SEND_REQUEST}
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>

        <Snackbar
          style={{ top: "80px" }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={snackData.show}
          autoHideDuration={3000}
          onClose={() => setSnackData({ show: false })}
        >
          <Alert
            onClose={() => setSnackData({ show: false })}
            severity={snackData.type}
          >
            {snackData.message}
          </Alert>
        </Snackbar>
      </AuthWrapper>
    </>
  );
}

ForgotPassword.propTypes = {
  isDemo: PropTypes.bool,
};
